/**
 * Find the maximum value in an array of numbers.
 */
export function max(a: number, b: number): number {
  return Math.max(a, b);
}
